import HomePage from '@/pages/HomePage.vue'
import InfoDisplayDashboard from '@/components/features/info-display/InfoDisplayDashboard.vue'
import InfoDisplayAreasCard from '@/components/features/info-display/InfoDisplayAreasCard.vue'
import InfoDisplayApartmentsCard from './components/features/info-display/InfoDisplayApartmentsCard.vue'
import InfoDisplayContentCard from '@/components/features/info-display/InfoDisplayContentCard.vue'
import InfoDisplayIndoorDataCard from './components/features/info-display/InfoDisplayIndoorDataCard.vue'
import InfoDisplayInformationCard from '@/components/features/info-display/InfoDisplayInformationCard.vue'
import InfoDisplayOverview from '@/components/features/info-display/InfoDisplayOverview.vue'
import InfoDisplayPlaceCard from '@/components/features/info-display/InfoDisplayPlaceCard.vue'
import InfoDisplayRoomEdit from './components/features/info-display/InfoDisplayRoomEdit.vue'
import InfoDisplayLineSummaryCard from '@/components/features/info-display/InfoDisplayLineSummaryCard.vue'
import InfoDisplayPoiSummaryCard from '@/components/features/info-display/InfoDisplayPoiSummaryCard.vue'
import InfoDisplayZoneSummaryCard from '@/components/features/info-display/InfoDisplayZoneSummaryCard.vue'
import FilesDashboard from './components/features/attachments/FilesDashboard.vue'
import LinksDashboard from './components/features/attachments/LinksDashboard.vue'
import TicketsDashboard from './components/features/tickets/TicketsDashboard.vue'
import DashboardFeatureUsage from '@/components/AnalyticsDashboard/DashboardFeatureUsage.vue'
import DashboardFeature from '@/components/AnalyticsDashboard/components/DashboardFeature.vue'
import DashboardDataSection from '@/components/AnalyticsDashboard/components/DashboardDataSection.vue'
import DashboardDataSectionFlat from '@/components/AnalyticsDashboard/components/DashboardDataSectionFlat.vue'
import DashboardDataSectionDynamic from './components/AnalyticsDashboard/components/DashboardDataSectionDynamic.vue'
import DashboardFeatureBuildingScore from '@/components/AnalyticsDashboard/BuildingScore/DashboardFeatureBuildingScore.vue'
import KPISection from '@/components/AnalyticsDashboard/components/KPISection.vue'
import BuildingScoreKpiSection from '@/components/AnalyticsDashboard/BuildingScore/BuildingScoreKpiSection.vue'
import BuildingScoreGraphSection from '@/components/AnalyticsDashboard/BuildingScore/BuildingScoreGraphSection.vue'
import GraphSection from '@/components/AnalyticsDashboard/components/GraphSection.vue'
import HeatmapSection from '@/components/AnalyticsDashboard/components/HeatmapSection.vue'
import IndoorClimateFilters from '@/components/AnalyticsDashboard/IndoorClimate/IndoorClimateFilters.vue'
import PortfolioAnalysisFilters from '@/components/portfolio-analysis/PortfolioAnalysisFilters.vue'
import ColorLegend from './design-system/atoms/ColorLegend.vue'
import { Component } from 'vue'
import MeasurementCard from './components/AnalyticsDashboard/components/MeasurementCard.vue'
import MainMeasurementCard from './components/AnalyticsDashboard/components/MainMeasurementCard.vue'
import ProjectMeasurementCard from './components/project-analysis/ProjectMeasurementCard.vue'
import IndexMeasurementCard from './components/AnalyticsDashboard/IndoorClimate/IndexMeasurementCard.vue'
import CardHeatmap from './components/AnalyticsDashboard/components/CardHeatmap.vue'
import CardTopList from './components/AnalyticsDashboard/components/CardTopList.vue'
import FeatureCard from './components/FeatureCard.vue'
import IconCheckDone1 from './design-system/assets/icons/IconCheckDone1.vue'
import IconInfoCircle from '@/design-system/assets/icons/IconInfoCircle.vue'
import IconInsertDriveFile from '@/design-system/assets/icons/IconInsertDriveFile.vue'
import IconLinkMedium from '@/design-system/assets/icons/IconLinkMedium.vue'
import IconTimeLine from '@/design-system/assets/icons/IconTimeLine.vue'
import IconPaperclip from './design-system/assets/icons/IconPaperclip.vue'
import ClockRefreshIcon from '@/design-system/assets/icons/IconClockRefresh.vue'
import ThermometerIcon from '@/design-system/assets/icons/IconThermometer.vue'
import IconAward from './design-system/assets/icons/IconAward.vue'
import IconTag from './design-system/assets/icons/IconTag.vue'
import IconUsers from './design-system/assets/icons/IconUsers.vue'
import IconTool2 from './design-system/assets/icons/IconTool2.vue'
import IconUserMinus from './design-system/assets/icons/IconUserMinus.vue'
import IconUserPlus from './design-system/assets/icons/IconUserPlus.vue'
import IconZap from './design-system/assets/icons/IconZap.vue'
import IconClockRefresh from './design-system/assets/icons/IconClockRefresh.vue'
import ProjectAnalysisFilters from '@/components/AnalyticsDashboard/components/ProjectAnalysisFilters.vue'
import TicketAnalysisFilters from '@/components/AnalyticsDashboard/tickets/TicketAnalysisFilters.vue'
import AggregateAnalysisFilters from './components/AnalyticsDashboard/aggregate/AggregateAnalysisFilters.vue'
import ProjectListTable from '@/components/AnalyticsDashboard/components/ProjectListTable.vue'
import TicketListTable from './components/AnalyticsDashboard/tickets/TicketListTable.vue'
import KPICard from './components/AnalyticsDashboard/components/cards/KPICard.vue'
import CardChart from './components/AnalyticsDashboard/components/CardChart.vue'
import DividerComponent from './components/AnalyticsDashboard/components/DividerComponent.vue'
import InteractiveColorLegend from './design-system/molecules/InteractiveColorLegend.vue'
import IconGlobe2 from './design-system/assets/icons/IconGlobe2.vue'
import IconCalendarCheck from './design-system/assets/icons/IconCalendarCheck.vue'
import IconFileCheck2 from './design-system/assets/icons/IconFileCheck2.vue'
import IconSearch from './design-system/assets/icons/IconSearch.vue'
import TimeSeriesCard from './components/AnalyticsDashboard/components/TimeSeriesCard.vue'
import DashboardFeatureNew from './components/AnalyticsDashboard/components/DashboardFeatureNew.vue'
import IconPlusMedium from './design-system/assets/icons/IconPlusMedium.vue'
import IconTruck from './design-system/assets/icons/IconTruck.vue'
import CardTopListNew from './components/AnalyticsDashboard/components/CardTopListNew.vue'
import HistogramCard from './components/AnalyticsDashboard/components/HistogramCard.vue'
import BarChartCard from './components/AnalyticsDashboard/components/BarChartCard.vue'
import CardHeatmapNew from './components/AnalyticsDashboard/components/CardHeatmapNew.vue'
import MainMeasurementCardNew from './components/AnalyticsDashboard/components/MainMeasurementCardNew.vue'
import IconMarkerPin from './design-system/assets/icons/IconMarkerPin.vue'
import IconMoveFolder from './design-system/assets/icons/IconMoveFolder.vue'
import IconFileSearch from './design-system/assets/icons/IconFileSearch.vue'
import IconEdit from './design-system/assets/icons/IconEdit.vue'
import IconEditSmall from './design-system/assets/icons/IconEditSmall.vue'
import IconMoreVertical from './design-system/assets/icons/IconMoreVertical.vue'
import IconDownload from './design-system/assets/icons/IconDownload.vue'
import IconArchive from './design-system/assets/icons/IconArchive.vue'
import IconTrash2Small from './design-system/assets/icons/IconTrash2Small.vue'
import IconTrash2Medium from './design-system/assets/icons/IconTrash2Medium.vue'
import FileDirectoryDashboard from './components/features/files/FileDirectoryDashboard.vue'
import IconPlusSquareSmall from './design-system/assets/icons/IconPlusSquareSmall.vue'
import IconFolderSmall from './design-system/assets/icons/IconFolderSmall.vue'
import IconUpload from './design-system/assets/icons/IconUpload.vue'
import IconExternalLinkSmall from './design-system/assets/icons/IconExternalLinkSmall.vue'
import IconSmallPaperClip from './design-system/assets/icons/IconSmallPaperClip.vue'

export const icons: Record<string, Component> = {
  IconCheckDone1,
  IconSearch,
  IconInfoCircle,
  IconInsertDriveFile,
  IconLinkMedium,
  IconTimeLine,
  IconPaperclip,
  ClockRefreshIcon,
  ThermometerIcon,
  IconAward,
  IconTag,
  IconUsers,
  IconTool2,
  IconUserMinus,
  IconUserPlus,
  IconZap,
  IconGlobe2,
  IconCalendarCheck,
  IconFileCheck2,
  IconClockRefresh,
  IconPlusMedium,
  IconTruck,
  IconMarkerPin,
  IconMoveFolder,
  IconFileSearch,
  IconEdit,
  IconEditSmall,
  IconMoreVertical,
  IconDownload,
  IconArchive,
  IconTrash2Small,
  IconTrash2Medium,
  IconPlusSquareSmall,
  IconFolderSmall,
  IconUpload,
  IconExternalLinkSmall,
  IconSmallPaperClip
}

export const components: Record<string, Component> = {
  HomePage,
  InfoDisplayDashboard,
  InfoDisplayAreasCard,
  InfoDisplayApartmentsCard,
  InfoDisplayContentCard,
  InfoDisplayIndoorDataCard,
  InfoDisplayInformationCard,
  InfoDisplayOverview,
  InfoDisplayPlaceCard,
  InfoDisplayRoomEdit,
  InfoDisplayLineSummaryCard,
  InfoDisplayPoiSummaryCard,
  InfoDisplayZoneSummaryCard,
  CardChart,
  DashboardFeatureUsage,
  DashboardFeature,
  DashboardFeatureNew,
  DashboardDataSection,
  DashboardDataSectionFlat,
  DashboardDataSectionDynamic,
  DashboardFeatureBuildingScore,
  DividerComponent,
  KPISection,
  KPICard,
  BuildingScoreKpiSection,
  BuildingScoreGraphSection,
  GraphSection,
  HeatmapSection,
  IndoorClimateFilters,
  ColorLegend,
  FilesDashboard,
  LinksDashboard,
  MeasurementCard,
  CardHeatmap,
  CardTopList,
  CardTopListNew,
  ProjectMeasurementCard,
  IndexMeasurementCard,
  MainMeasurementCard,
  MainMeasurementCardNew,
  FeatureCard,
  ProjectAnalysisFilters,
  PortfolioAnalysisFilters,
  ProjectListTable,
  TicketListTable,
  TicketsDashboard,
  TicketAnalysisFilters,
  AggregateAnalysisFilters,
  InteractiveColorLegend,
  TimeSeriesCard,
  HistogramCard,
  BarChartCard,
  CardHeatmapNew,
  FileDirectoryDashboard,
  ...icons
}

export default components
